import {
  SET_TAX_MAPS_LOADING,
  GET_TAX_MAPS_STATES_SUCCESS,
  TaxMapsState,
  TaxMapsTypes,
  GET_TAX_MAPS_DRIVERS_SUCCESS,
  TAX_MAPS_RESULT_SUCCESS,
  RESET_DRIVERS_DATA,
  RESET_RESULTS,
} from './TaxMaps.types';

const defaultState = {
  loading: false,
  usState: null,
  result: null,
  driversData: null,
};

export function taxMapsReducer(
  state = defaultState,
  action: TaxMapsTypes,
): TaxMapsState {
  switch (action.type) {
    case GET_TAX_MAPS_STATES_SUCCESS: {
      return {
        ...state,
        usState: action.usState,
        loading: false,
      };
    }
    case SET_TAX_MAPS_LOADING: {
      return {
        ...state,
        loading: action.loading,
      };
    }
    case TAX_MAPS_RESULT_SUCCESS: {
      return {
        ...state,
        result: action.result,
        loading: false,
      };
    }
    case GET_TAX_MAPS_DRIVERS_SUCCESS: {
      return {
        ...state,
        driversData: action.driversData,
        loading: false,
      };
    }
    case RESET_DRIVERS_DATA: {
      return {
        ...state,
        driversData: null,
      };
    }
    case RESET_RESULTS: {
      return {
        ...state,
        result: null,
      };
    }
    default:
      return state;
  }
}
